import React from 'react';
import PropTypes from 'prop-types';
import { FDAvatar, FDPaper, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';


export const ClientRiskToleranceLayout = ({ resource }) => {
  return (
    <FDPaper color={'subtle'} appearance={'flat'} padding={2}>
      <FDStack direction={'column'} spacing={1}>
        <FDStack spacing={1} alignItems={'center'}>
          {resource.withRelationship(fr.relationships.image.name,
            (rel) => <FDAvatar src={rel.link('related').url()} alt={'profile image'} size={'sm'} />,
            () => null)}
          <FDStack direction={'column'} spacing={1}>
            <MetaControlField attr={'name'} />
          </FDStack>
        </FDStack>
        {/* This is a bit unintuitive, but this resource has an attribute "readonly" on it that drives whether or not we should show the
        slider for that particular client (eg. we want the slider to be disabled for the primary client but enabled for the secondary client.)
        This is not necessarily the same as the "readonly" property on the meta. */}
        <MetaControlField attr={'riskTolerance'} readonly={resource.attr('readonly') === 'true'} />
      </FDStack>
    </FDPaper>
  );
};


ClientRiskToleranceLayout.propTypes = {
  resource: PropTypes.object.isRequired,
};
